/* eslint-disable no-unused-vars */
import { Button, IconButton, useMediaQuery } from "@mui/material";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteDialog from "../../DeleteDialog/DeleteDialog";
import "./PieceListItem.css";
import { buttonStyles, cardBackground, cardText } from "./styleConstants";
import Locale from "../../../locales";
import UpdateDialog from "../UpdateDialog/UpdateDialog";
import {
  deletePiece,
  updatePieceStatus,
  updatePieceStartDate,
} from "../../../redux/actions";
import { piecesStatuses } from "../../../constants/piecesStatuses";
import { getPieceDateReport } from "../../../shared/getPieceDateReport";
import StartDateDialog from "../StartDateDialog/StartDateDialog";
import { teacherRequestFail } from "../../../redux/actions/teacher";
import { PIECES_STATUS } from "../../../constants/pieces";

const useStyles = makeStyles({
  removeButton: {
    width: "60px",
  },
  actionButton: {
    height: "100%",
    width: "120px",
  },
  stopButton: {
    height: "100%",
    width: "120px",
  },
  inCompletedButton: {
    height: "100%",
    width: "130px",
  },
  mobileActionButton: {
    height: "100%",
  },
  mobileStopButton: {
    height: "100%",
  },
});

const PieceListItem = ({ piece }) => {
  const loading = useSelector((state) => state.teacherReducer.loading);
  const [newStatus, setNewStatus] = useState("idle");
  const studentId = useSelector((state) => state.teacherReducer.currentStudent);
  const [previousStatus, setPreviousStatus] = useState("");
  const [open, setOpen] = useState(false);
  const [deletingPiece, setDeletingPiece] = useState(null);
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const styles = useStyles();
  const dispatch = useDispatch();
  const isSmall = useMediaQuery("(max-width:1400px)");

  const [updateStartDateOpen, setUpdateStartDateOpen] = useState(false);
  const [newStartDate, setNewStartDate] = useState(new Date().toISOString());
  // const daysTaken = moment(new Date(piece.endDateTimeISO));

  const { startDateTimeISO, endDateTimeISO, pieceStatus } = piece;

  const { pieceStartDate, pieceEndDate, timeTaken } = getPieceDateReport({
    startDateTimeISO,
    endDateTimeISO,
  });

  const deleteHandler = (pieceId) => {
    setOpen(true);
    setDeletingPiece(pieceId);
  };
  const confirmDelete = () => {
    dispatch(deletePiece(deletingPiece, studentId));
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
    setDeletingPiece(null);
  };

  const updateStatusHandler = () => {
    setUpdateDialogOpen(true);
  };
  const handleUpdateDialogClose = () => {
    setUpdateDialogOpen(false);
    setNewStatus("");
  };
  const updateStartDateHandler = () => {
    setUpdateStartDateOpen(true);
  };
  const handleStartDateDialogClose = () => {
    setUpdateStartDateOpen(false);
  };

  const changeStatusHandler = () => {
    const data = {
      pieceId: piece.pieceId,
      newPieceStatus: newStatus,
      previousPieceStatus: previousStatus,
      currentDateTimeISO: new Date().toISOString(),
      studentId,
    };

    dispatch(updatePieceStatus(data));
    setUpdateDialogOpen(false);
  };

  const changeStartDateHandler = () => {
    if (newStartDate && pieceEndDate && pieceStatus !== PIECES_STATUS.ONGOING) {
      const startDate = moment(newStartDate).format("YYYY-MM-DD");
      const endDate = moment(pieceEndDate).format("YYYY-MM-DD");

      if (moment(startDate).isAfter(endDate)) {
        return dispatch(
          teacherRequestFail(
            Locale.t("start_date_should_be_less_that_end_data"),
          ),
        );
      }
    }

    const data = {
      pieceId: piece.pieceId,
      newPieceStatus: piece.pieceStatus,
      previousPieceStatus: piece.pieceStatus,
      currentDateTimeISO: new Date().toISOString(),
      updatedStartDateTimeISO: new Date(newStartDate).toISOString(),
      endDateTimeISO: piece.endDateTimeISO,
      studentId,
    };
    dispatch(updatePieceStartDate(data));
    return setUpdateStartDateOpen(false);
  };

  return (
    <div className={cardBackground[piece.pieceStatus]}>
      <DeleteDialog
        open={open}
        handleClose={handleClose}
        confirmDelete={confirmDelete}
        message="are_you_sure_you_want_to_delete_piece"
      />
      <UpdateDialog
        setPreviousStatus={setPreviousStatus}
        newStatus={newStatus}
        setNewStatus={setNewStatus}
        updateDialogOpen={updateDialogOpen}
        handleUpdateDialogClose={handleUpdateDialogClose}
        changeStatusHandler={changeStatusHandler}
      />
      <StartDateDialog
        setNewStartDate={setNewStartDate}
        updateStartDateOpen={updateStartDateOpen}
        newStartDate={newStartDate}
        handleStartDateDialogClose={handleStartDateDialogClose}
        changeStartDateHandler={changeStartDateHandler}
      />

      <div className="piece-action-buttons-container">
        <Button
          onClick={updateStatusHandler}
          disabled={loading}
          color="primary"
          sx={buttonStyles.actionButtonSx}
          variant="contained"
          className={isSmall ? styles.mobileActionButton : styles.actionButton}>
          {Locale.t("update_status")}
        </Button>
        <Button
          onClick={updateStartDateHandler}
          disabled={loading}
          color="primary"
          variant="contained"
          className={isSmall ? styles.mobileActionButton : styles.actionButton}>
          {Locale.t("update_start_date")}
        </Button>
      </div>

      <div className="piece-item-details">
        <p className="piece-status-text">{cardText[piece.pieceStatus]}</p>

        <div>
          <h3>{piece.pieceTitle}</h3>
        </div>
        <p>{piece.pieceDescription}</p>
        <div className="piece-status-date">
          {pieceStartDate !== null ? (
            <div className="piece-status-date-box">
              <div className="piece-status-date-box-title">Start Date</div>
              <div className="piece-status-date-box-value">
                {pieceStartDate}
              </div>
            </div>
          ) : null}
          {(pieceEndDate !== null && piece.pieceStatus === piecesStatuses[2]) ||
          piece.pieceStatus === piecesStatuses[3] ? (
            <div className="piece-status-date-box">
              <div className="piece-status-date-box-title">End Date</div>
              <div className="piece-status-date-box-value">{pieceEndDate}</div>
            </div>
          ) : null}
        </div>
      </div>

      <div className="icon-button">
        {piece.pieceStatus !== piecesStatuses[0] &&
        piece.pieceStatus !== piecesStatuses[1] ? (
          <div className="piece-status-date-box total-days-container">
            <div className="piece-status-date-box-title">Days</div>
            <div className="piece-status-date-box-value">{timeTaken}</div>
          </div>
        ) : null}
        <IconButton
          onClick={() => deleteHandler(piece.pieceId)}
          disabled={loading}
          color="error"
          variant="contained">
          <DeleteIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default PieceListItem;
